// Login.js - Updated with secure authentication and better error handling
import React, { useState } from "react";
import { openDialog, closeDialog } from "./Application";
import Authentication from "./Authentication";

const Login = ({ onLogin }) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setIsLoading(true);

        // Basic validation
        if (!username.trim()) {
            setError("Please enter your username");
            setIsLoading(false);
            return;
        }

        if (!password.trim()) {
            setError("Please enter your password");
            setIsLoading(false);
            return;
        }

        try {
            const result = await Authentication.login(username, password);

            if (result.success) {
                closeDialog();
                onLogin?.(result.user);
            } else {
                setError(result.error || "Login failed");
            }
        } catch (error) {
            console.error("Login error:", error);
            setError("An unexpected error occurred. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    // Handle Enter key press
    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !isLoading) {
            handleSubmit(e);
        }
    };

    return (
        <div>
            <form onSubmit={handleSubmit}>
                {error && (
                    <div
                        className="error"
                    >
                        {error}
                    </div>
                )}

                <div style={{ marginBottom: "15px" }}>
                    <input
                        type="text"
                        placeholder="Usuario"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        onKeyPress={handleKeyPress}
                        required
                        disabled={isLoading}
                    />
                </div>

                <div style={{ marginBottom: "15px" }}>
                    <input
                        type="password"
                        placeholder="Contraseña"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyPress={handleKeyPress}
                        required
                        disabled={isLoading}
                    />
                </div>

                <button
                    type="submit"
                    disabled={isLoading}
                >
                    {isLoading ? "Iniciando sesión..." : "Entrar"}
                </button>
            </form>
        </div>
    );
};

export default Login;

const openLoginDialog = (callback) => {
    openDialog(
        'login',
        {
            onLogin: callback
        },
        'Login Required',
        'small'
    );
};

export { openLoginDialog };
